module.exports = "<p>Join daily guided tours, hear from the artist, download the app or get hands on at a workshop inspired by Pipilotti Rist’s celebration of nature, the body and the senses.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/news/eventsandtours-excerpt.md
// module id = 816
// module chunks = 0